import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { TokenService } from '../../../services/auth/token.service';
import { TablelayoutService } from '../../users/data/tablelayout.service';
import { ProductionReceiptsService } from '../../production/data/production-receipts.service';
import { InvoicesService } from '../data/invoices.service';
import { CustomerService } from '../../customers/data/customer.service';
import { TranslateService } from '../../../services/multilingual/translate.service';
import { ModalService } from '../../../components/JBM/JBMModal/service/modal.service';
import { DatetimeService } from '../../../services/datetime/datetime.service';
import { PlantsService } from '../../company/data/plants.service';
import { JBMSelectOption } from '../../../components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component';
import { JBMToastsService } from '../../../components/JBM/Views/JBMToasts/JBMToasts.service';
import { UserPreferences, UserPreferencesService } from 'src/app/services/storage/user_preferences.service';
import { QueryHttpHelper } from 'src/app/components/JBM/Helpers/QueryHttpHelper';
import { Subscription } from 'rxjs';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDatepickerKeyboardService } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18n } from '../../../services/NgbDatepicker/custom-datepicker-i18n.service';
import { CustomAdapter } from '../../../services/NgbDatepicker/custom-adapter.service';
import { CustomDateParserFormatter } from '../../../services/NgbDatepicker/custom-dateparser-formatter.service';
import { CustomKeyboardService } from '../../../services/NgbDatepicker/custom-keyboard-service';
import { EventService } from 'src/app/services/event.service';
import { JBMTableColumnType, JBMTableColumnDef, JBMTableComponent, JBMTableColumnAlignment } from 'src/app/components/JBM/JBMTable/JBMTable.component';

const tableName = 'invoiceable-receipts';

const deliveryState = {
  complete: 0,
  partly: 1,
  none: 2,
  dropped: 3,
  productionCancelled: 4,
};

@Component({
  selector: 'invoiceable-receipts',
  templateUrl: './invoiceable-receipts.component.html',
  styleUrls: ['./invoiceable-receipts.component.scss'],
  providers: [
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }, // define custom NgbDatepickerI18n provider
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDatepickerKeyboardService, useClass: CustomKeyboardService },
  ],
})
export class InvoiceableReceiptsComponent implements OnInit, AfterViewInit, OnDestroy {
  language: string;
  columnDefs: JBMTableColumnDef[] = [];
  queryHttpHelper: QueryHttpHelper;
  initialCount: number = 0;
  receipts: any[] = [];
  receipt_ids: number[] = [];
  filtersVisible = true;
  plantOptions: JBMSelectOption[] = [];
  projects: any[] = [];
  projects_id: number = 0;
  project_name: string = '';
  modal_projects_id: number = 0;
  plant_id: number = 0;
  plants_id: number = 0;
  customer: any;
  loading: boolean = false;
  expanded: number = -1;
  itemCount: number = 0;
  delivery_date: string = '';
  recipe_id: number = 0;
  order_id: number = 0;
  environment: string = '';
  userPreferences: UserPreferences = this.UserPreferencesService.getDefault();

  date: string = this.DatetimeService.getCurrentDateDMY();
  dateTouched: boolean = false;

  count$: Subscription;

  @Output() onStartLoading = new EventEmitter();
  @Output() onStopLoading = new EventEmitter();

  @ViewChild('table') table: JBMTableComponent;

  @ViewChild('templateCheck') templateCheck: TemplateRef<any>;
  @ViewChild('templateCustomer') templateCustomer: TemplateRef<any>;
  @ViewChild('templateProject') templateProject: TemplateRef<any>;
  @ViewChild('templateRecipe') templateRecipe: TemplateRef<any>;
  @ViewChild('templateOrder') templateOrder: TemplateRef<any>;
  @ViewChild('templateDelivery') templateDelivery: TemplateRef<any>;

  @ViewChild('modalCustomerDetails') modalCustomerDetails: ElementRef;
  @ViewChild('modalProjectDetails') modalProjectDetails: ElementRef;

  @ViewChild('modalRecipe') modalRecipe: ElementRef;
  @ViewChild('modalOrder') modalOrder: ElementRef;

  constructor(
    private Router: Router,
    private TokenService: TokenService,
    private TablelayoutService: TablelayoutService,
    private ProductionReceiptsService: ProductionReceiptsService,
    private InvoicesService: InvoicesService,
    private CustomerService: CustomerService,
    private PlantsService: PlantsService,
    private TranslateService: TranslateService,
    private UserPreferencesService: UserPreferencesService,
    private ModalService: ModalService,
    private DatetimeService: DatetimeService,
    private JBMToastsService: JBMToastsService,
    private EventService: EventService,
  ) {
    this.language = this.TokenService.getLanguage();

    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.addAliasedColumn('receipts_id', 'r.receipts_id');
    this.queryHttpHelper.addAliasedColumn('plant', 'pl.code');
    this.queryHttpHelper.addAliasedColumn('customer', 'c.name');
    this.queryHttpHelper.addAliasedColumn('project', 'p.name');
    this.queryHttpHelper.addAliasedColumn('project_id', 'p.id');
    this.queryHttpHelper.addAliasedColumn('order_description', 'o.description');
    this.queryHttpHelper.addAliasedColumn('order_delivered', 'o.delivered');
    this.queryHttpHelper.addAliasedColumn('orders_id', 'o.id');
    this.queryHttpHelper.addAliasedColumn('delivered', 'o.delivered');
    this.queryHttpHelper.addAliasedColumn('public_id', 'recipe.public_id');
    this.queryHttpHelper.addAliasedColumn('comments', 'o.comments');
    this.queryHttpHelper.addAliasedColumn('recipe', 'recipe.description');
    this.queryHttpHelper.addAliasedColumn('recipe_comments', 'o.recipe_comments');

    this.queryHttpHelper.setSortColumn('production_date', true);

    this.columnDefs = [
      { name: 'id', type: JBMTableColumnType.id, tag: 'id' },
      { name: 'check', type: JBMTableColumnType.custom, iconClassname: 'far fa-check', visible: true, hideable: false, width: 3, moveable: false },
      { name: 'production_date', type: JBMTableColumnType.string, header: this.TranslateService.GetTranslation('order.delivery-date'), visible: true, hideable: true, sortable: true, moveable: true, width: 6 },
      {
        name: 'customer',
        type: JBMTableColumnType.stringAndID,
        IDName: 'customer_id',
        header: this.TranslateService.GetTranslation('entity.customer'),
        visible: true,
        hideable: false,
        sortable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 12,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'project',
        type: JBMTableColumnType.stringAndID,
        IDName: 'project_id',
        header: this.TranslateService.GetTranslation('entity.project'),
        visible: true,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 12,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'location',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('project.work-location'),
        visible: false,
        hideable: true,
        sortable: false,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 12,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'order_description',
        type: JBMTableColumnType.stringAndID,
        IDName: 'orders_id',
        header: this.TranslateService.GetTranslation('project.order'),
        visible: true,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 10,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'comments',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('project.order-short'),
        iconClassname: 'fas fa-comments',
        visible: false,
        hideable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 12,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'worktype',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('order.worktype'),
        visible: false,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 10,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'receipts_id',
        type: JBMTableColumnType.number,
        align: JBMTableColumnAlignment.left,
        header: this.TranslateService.GetTranslation('production.receipt') + this.TranslateService.GetTranslation('ui.number-short'),
        visible: true,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        width: 4,
      },
      {
        name: 'loadtime',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('datetime.start'),
        iconClassname: 'far fa-clock',
        visible: false,
        hideable: true,
        sortable: true,
        moveable: true,
        width: 4.5,
      },
      {
        name: 'starttime',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('datetime.stop'),
        iconClassname: 'far fa-clock',
        visible: false,
        hideable: true,
        sortable: true,
        moveable: true,
        width: 4.5,
      },
      {
        name: 'public_id',
        type: JBMTableColumnType.number,
        header: this.TranslateService.GetTranslation('entity.recipe') + this.TranslateService.GetTranslation('ui.id').toLowerCase(),
        visible: false,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        width: 5,
      },
      {
        name: 'recipe',
        type: JBMTableColumnType.stringAndID,
        IDName: 'public_id',
        header: this.TranslateService.GetTranslation('entity.recipe'),
        visible: true,
        hideable: true,
        sortable: true,
        filterable: true,
        moveable: true,
        sizeable: true,
        width: 12,
        minWidth: 5,
        maxWidth: 25,
      },
      {
        name: 'recipe_comments',
        type: JBMTableColumnType.string,
        header: this.TranslateService.GetTranslation('entity.recipe') + ' ' + this.TranslateService.GetTranslation('entity.notes').toLowerCase(),
        iconClassname: 'fas fa-comments',
        visible: false,
        hideable: true,
        sortable: false,
        filterable: false,
        moveable: true,
        sizeable: true,
        width: 10.5,
        minWidth: 5,
        maxWidth: 25,
      },
      { name: 'order_delivered', type: JBMTableColumnType.number, header: this.TranslateService.GetTranslation('order.delivered'), visible: true, hideable: true, sortable: true, filterable: true, moveable: true, width: 5 },
      { name: 'order_amount', type: JBMTableColumnType.number, header: this.TranslateService.GetTranslation('order.ordered'), visible: true, hideable: true, sortable: true, filterable: true, moveable: true, width: 4.5 },
      { name: 'delivery', type: JBMTableColumnType.string, header: this.TranslateService.GetTranslation('ui.delivery'), visible: true, hideable: true, moveable: true, width: 7 },
      { name: 'plant', type: JBMTableColumnType.string, header: this.TranslateService.GetTranslation('company.plant'), visible: false, hideable: true, sortable: false, moveable: true, width: 6 },
    ];

    this.TablelayoutService.initLayout(tableName, this.columnDefs);
  }

  ngOnInit(): void {
    let plants: any[] = [];
    this.PlantsService.getData().subscribe(
      (data: any) => (plants = data.data),
      (error: any) => console.error(error),
      () => {
        if (plants.length > 1) {
          this.plantOptions = this.PlantsService.getSelectOptions(plants);
          this.plantOptions.unshift({ key: '0', value: this.TranslateService.GetTranslation('ui.all') });
        }

        this.UserPreferencesService.get().subscribe(
          (settings: any) => {
            this.userPreferences = settings;
            this.getData(true);
          },
          (error: any) => console.error(error),
        );
      },
    );
  }
  ngAfterViewInit(): void {
    this.EventService.on('userpreferences').subscribe(() =>
      this.UserPreferencesService.get().subscribe((settings: any) => {
        this.userPreferences = settings;
      }),
    );

    setTimeout(() => {
      this.queryHttpHelper.paginationProps.pageSize = this.table.getRowCount();
    });
  }
  getData(countRows: boolean = false) {
    this.loading = true;
    this.onStartLoading.emit();

    let params = this.queryHttpHelper.getHttpParams(false);
    if (this.plants_id) params = params.append('plants_id', this.plants_id.toString());
    if (this.projects_id) params = params.append('projects_id', this.projects_id.toString());

    this.ProductionReceiptsService.getInvoiceableReceipts(this.language, params).subscribe(
      (data: any) => (this.receipts = data.data),
      (error: any) => console.error(error),
      () => {
        this.loading = false;
        this.onStopLoading.emit();
        this.formatReceipts();
        if (countRows) {
          let params = this.queryHttpHelper.getHttpParams(true);
          if (this.plants_id) params = params.append('plants_id', this.plants_id.toString());
          if (this.projects_id) params = params.append('projects_id', this.projects_id.toString());

          this.count$ = this.ProductionReceiptsService.getInvoiceableReceipts(this.language, params).subscribe(
            (data: any) => {
              this.itemCount = data.data;
              if (!this.initialCount) this.initialCount = this.itemCount;
              this.queryHttpHelper.paginationProps.itemCount = data.data;
            },
            (error: any) => console.error(error),
          );
        }
      },
    );

    this.table.setColumnTemplate('check', this.templateCheck);
    this.table.setColumnTemplate('customer', this.templateCustomer);
    this.table.setColumnTemplate('project', this.templateProject);
    this.table.setColumnTemplate('recipe', this.templateRecipe);
    this.table.setColumnTemplate('order_description', this.templateOrder);
    this.table.setColumnTemplate('delivery', this.templateDelivery);
  }
  changePlant(event: any) {
    this.plants_id = parseInt(event.target.value);
    this.getData(true);
  }
  saveLayout(columnDefs: JBMTableColumnDef[]) {
    this.TablelayoutService.setTableColumns(columnDefs);
    this.TablelayoutService.saveLayout();
  }
  formatReceipts() {
    for (let receipt of this.receipts) {
      receipt.order_amount = receipt.order_amount.toString().replace('.', ',') + ' ' + this.TranslateService.GetTranslation('quantity.m3');
      if (!receipt.dropped) receipt.order_delivered = receipt.order_delivered.toString().replace('.', ',') + ' ' + this.TranslateService.GetTranslation('quantity.m3');
      else receipt.order_delivered = '';
      receipt.order_open = receipt.order_open.toString().replace('.', ',') + ' ' + this.TranslateService.GetTranslation('quantity.m3');
      if (receipt.production_date) receipt.production_date = this.DatetimeService.dateYMDToDMY(receipt.production_date);
    }
  }
  rowCountChange(rowCount: number) {
    this.queryHttpHelper.paginationProps.pageSize = rowCount;
    this.getData();
  }
  sortChange(event: any) {
    this.queryHttpHelper.setSortColumn(event.name, event.descending);
    this.getData();
  }
  toggleFilters(event: any) {
    this.filtersVisible = !this.filtersVisible;
    this.queryHttpHelper.clearFilters();
    this.queryHttpHelper.setSearchValue('');

    this.getData(true);
  }
  resetFilters() {
    this.queryHttpHelper.clearFilters();
    if (this.filtersVisible) this.table.resetColumnFilters();
    this.plants_id = 0;
    this.projects_id = 0;

    this.getData(true);
  }
  filterChange(event: any) {
    console.log(event);
    // Delete receipt id number filter when another filter becomes active
    if (event.name !== 'receipts_id') {
      this.queryHttpHelper.deleteFilterItem('receipts_id');
      this.table.resetColumnFilter('receipts_id');
    }
    // Delete other filters when receipt id number filter becomes active
    if (event.name === 'receipts_id') {
      this.queryHttpHelper.clearFilters();
      this.table.resetColumnFilters();
    }

    this.queryHttpHelper.setFilterItem(event.name, event.value);
    this.getData(true);
  }
  pageChange(page: number) {
    this.queryHttpHelper.paginationProps.page = page;
    this.getData();
  }
  // Customer
  showCustomer(customer_id: number) {
    this.CustomerService.get(customer_id, true).subscribe(
      (data: any) => (this.customer = data.data),
      (error: any) => console.error(error),
      () => this.ModalService.open(this.modalCustomerDetails, 'customerDetails'),
    );
  }
  closeCustomer() {
    this.ModalService.close('customerDetails');
  }

  onChangeDate() {
    this.dateTouched = true;
  }
  validateDate() {
    if (this.date === null) return true;
    this.date = this.date.trim();
    return !this.date || this.DatetimeService.validateDateStr(this.date);
  }
  resetSelection() {
    this.receipt_ids = [];
    this.projects_id = 0;
    this.getData(true);
  }
  generateInvoice(project_id: number, receipt_id: number = 0) {
    let invoice_date = this.DatetimeService.dateDMYToYMD(this.date);
    this.InvoicesService.createFromReceipts(this.language, project_id, receipt_id.toString(), invoice_date).subscribe(
      () => {},
      (error: any) => console.error(error),
      () => {
        this.getData(true);
        this.JBMToastsService.success(this.TranslateService.GetTranslation('ui.entity-saved'));
      },
    );
  }
  generateReceiptsInvoice() {
    if (!this.receipts.length) return;
    let receipt_id = this.receipt_ids[0];
    let receipt = this.receipts.find((r: any) => r.id === receipt_id);
    let project_id = receipt.project_id;

    let invoice_date = this.DatetimeService.dateDMYToYMD(this.date);
    let receipt_ids = this.receipt_ids.join();
    this.InvoicesService.createFromReceipts(this.language, project_id, receipt_ids, invoice_date).subscribe(
      () => {},
      (error: any) => console.error(error),
      () => {
        this.receipt_ids = [];
        this.getData(true);
        this.JBMToastsService.success(this.TranslateService.GetTranslation('ui.entity-saved'));
      },
    );
  }
  getProjects(event: any) {
    if (!event.search) return;

    let params = new HttpParams();
    if (this.plants_id) params = params.append('plants_id', this.plants_id);
    if (event.search) params = params.append('search', event.search);

    this.ProductionReceiptsService.getInvoiceableProjects(this.language, params).subscribe(
      (data: any) => {
        this.projects = [];
        for (let row of data.data) this.projects.push({ id: row.project.id, name: row.project.name });
      },
      (error: any) => console.error(error),
    );
  }
  selectProject(project: any) {
    this.projects_id = project.id;
    this.receipt_ids = [];
    this.getData(true);
  }
  toggleProject() {
    let toggledReceipts = this.receipt_ids.length;
    this.receipt_ids = [];
    // Reset ?
    if (toggledReceipts === this.receipts.length) return;
    // Select all
    for (let receipt of this.receipts) this.receipt_ids.push(receipt.id);
  }
  toggleReceipt(receipt: any) {
    if (!this.projects_id) {
      this.receipt_ids = [];
      this.projects_id = receipt.project_id;
      this.project_name = receipt.project;
      this.getData(true);
    }

    let receipt_index = this.receipt_ids.indexOf(receipt.id);
    if (receipt_index === -1) this.receipt_ids.push(receipt.id);
    else this.receipt_ids.splice(receipt_index, 1);

    if (this.projects_id && !this.receipt_ids.length) {
      this.projects_id = 0;
      this.project_name = '';
      this.getData(true);
    }
  }
  // Project
  showProject(project_id: number) {
    this.modal_projects_id = project_id;
    this.ModalService.open(this.modalProjectDetails, 'projectDetails');
  }
  closeProject() {
    this.ModalService.close('projectDetails');
  }
  showRecipe(plant_id: number, recipe_id: number, delivery_date: string, environment: string) {
    this.plant_id = plant_id;
    this.recipe_id = recipe_id;
    this.delivery_date = delivery_date;
    this.environment = environment;
    this.ModalService.open(this.modalRecipe, 'recipe');
  }
  closeRecipe() {
    this.ModalService.close('recipe');
  }
  // Order
  showOrder(order_id: number) {
    this.order_id = order_id;
    this.ModalService.open(this.modalOrder, 'order');
  }
  closeOrder() {
    this.ModalService.close('order');
  }
  ngOnDestroy(): void {
    // Clean up observable subscriptions to avoid memory leaks
    if (this.count$ != undefined) this.count$.unsubscribe();
  }

  public readonly deliveryState = deliveryState;
}
